<template>
  <div id="ManualSet">
    <template>
      <ots-main-title></ots-main-title>
      <div class="titleback">
        <div class="topTip">
          <span class="f18 col_black mr20"
            >{{ this.paramslist.planName }}
            {{ this.paramslist.sessionName }}</span
          >
          <div class="titlelist">
            <span>考试时间：{{ beginTime }}至{{ endTime }}</span>
            <p>
              <a>考点：</a><span>{{ this.paramslist.placeName }}</span>
            </p>
            <p>
              <a>教室：</a><span>{{ this.paramslist.className }}</span>
            </p>
            <p>
              <a>考位：</a><span>{{ this.paramslist.classSeatNumber }}</span>
            </p>
          </div>
        </div>
      </div>
      <p>
        <a> 关键词：</a>
        <el-input
          placeholder="姓名/准考证/证件号"
          @blur="blur"
          v-model="searchKey"
        ></el-input>
      </p>
      <div class="mainCon">
        <ots-table-group
          :requestForm="requestForm"
          :tableHeader="tableHeader"
          :batchOperBtn="batchOperBtn"
          :tableData="tableData"
          @handleSelectionChange="bachOper"
          :pagination="pagination"
          :tableOption="tableOption"
        ></ots-table-group>
      </div>
    </template>
    <ots-custom-dialog :dialog.sync="addDialog" title="单个调整" width="40%">
      <template v-slot:content>
        <div class="inputval">
          <div>调整学生去</div>
          <div class="sessionlist">
            场次
            <el-select v-model="sessionIdTag" placeholder="请选择">
              <el-option
                v-for="item in sessionIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="sessionlist">
            考场
            <el-select v-model="valueplaceId" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.classId"
                :label="item.className + '(' + item.leftSeat + ')'"
                :value="item.classId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="leftSeatshow" v-if="leftSeatshow">
            该考场剩余容量不足，确定调整吗？
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="addDialog = false">取消</el-button>
        <el-button round type="primary" @click="addSchool()">确定</el-button>
      </template>
    </ots-custom-dialog>
    <ots-custom-dialog
      :dialog.sync="alladdDialog"
      title="批量调整考场安排"
      width="40%"
    >
      <template v-slot:content>
        <div class="inputval">
          <div>选中的{{ selectidsLength }}名学生批量调整去</div>
          <div class="sessionlist">
            场次
            <el-select v-model="allSessionIdTag" placeholder="请选择">
              <el-option
                v-for="item in allSessionIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="sessionlist">
            考场
            <el-select v-model="allValue" placeholder="请选择">
              <el-option
                v-for="item in optionsList"
                :key="item.classId"
                :label="item.className + '(' + item.leftSeat + ')'"
                :value="item.classId"
              >
              </el-option>
            </el-select>
          </div>
          <div class="leftSeatshow" v-if="leftSeatshow">
            该考场剩余容量不足，确定调整吗？
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="alladdDialog = false">取消</el-button>
        <el-button round type="primary" @click="allAddSchool">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>
    
    <script>
import {
  getOtherClassesFn,
  getClassesStudentInfoFn,
  saveChangePlanClassFn,
  getSingleSection,
} from "@/http/modules/examSet/section";
import { getPlanAllSessionByPlan } from "@/http/modules/examSet/planClass";
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";

export default {
  data() {
    return {
      sessionIdList: [],
      allSessionIdList: [],
      sessionIdTag: '',
      allSessionIdTag:'' ,//批量
      searchKey: "",
      allValue: "",
      alladdDialog: false,
      addDialog: false,
      options: [],
      optionsList: [],
      valueplaceId: "",
      tableData: [],
      tableHeader: [
        {
          title: "座位号",
          prop: "seatNo",
        },
        {
          title: "姓名",
          prop: "studentName",
        },

        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "考试科目",
          prop: "courseName",
        },
        {
          title: "操作",
          type: "buttons",
          width: "160",
          btnList: [
            {
              title: "调整",
              click: this.allAdjustment,
            },
          ],
        },
      ],

      pagination: {
        total: 0,
      },
      paramslist: {},
      requestForm: {
        classId: "",
        placeId: "",
        planId: "",
        sessionId: "",
      },
      tableOption: {
        multiple: true,
      },
      singlestudentCourseId: "",
      selectIds: [],
      batchOperBtn: [
        {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
        {
          title: "批量调整",
          click: this.studentAdjustments,
        },
      ],
      selectidsLength: "",
      leftSeatshow: false,
      classIdTarget: "",
      allclassIdTarget: "",
      beginTime: "",
      endTime: "",
    };
  },
  watch: {
    allValue: function (val) {
      if (this.allValue) {
        let leftSeat = this.optionsList.filter((item) => item.classId == val);
        let leftSeatNumber = leftSeat[0].leftSeat;
        this.allclassIdTarget = leftSeat[0].classId;
        if (this.selectidsLength > leftSeatNumber) {
          this.leftSeatshow = true;
        }else{
          this.leftSeatshow = false
        }
      }
    },
    valueplaceId: function (val) {
      if (this.valueplaceId) {
        let leftSeat = this.options.filter((item) => item.classId == val);
        let leftSeatNumber = leftSeat[0].leftSeat;
        this.classIdTarget = leftSeat[0].classId;
        if (leftSeatNumber < 1) {
          this.leftSeatshow = true;
        }else{
          this.leftSeatshow = false
        }
      }
    },
    sessionIdTag() {
      this.getOtherClasses();
    },
    allSessionIdTag() {
      this.allgetOtherClasses();
    },
  },
  created() {
    this.paramslist = JSON.parse(window.localStorage.getItem("paramslist"));
    this.getSingleSectionFn();
    this.getCurrentPlan();
    this.getClassesStudentInfo();
  },
  methods: {
    async getPlanAllSession(val) {
      let params = {
        planId: this.paramslist.planId,
      };
      const { data } = await getPlanAllSessionByPlan(params);
      this.requestForm.sessionId = "";
      this.sessionIdList = data;
      this.allSessionIdList = data;
    },
    async getSingleSectionFn() {
      const { data } = await getSingleSection({
        sessionId: this.paramslist.sessionId,
      });
      this.beginTime = data.beginTime;
      this.endTime = data.endTime;
    },
    async getCurrentPlan() {
      let { data } = await getCurrentPlanFn({
        planId: this.paramslist.planId,
      });
    },

    bachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.studentCourseId);
      });
      this.selectIds = idList;
    },
    blur() {
      let params = {
        classId: this.paramslist.classId,
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        searchKey: this.searchKey,
      };
      getClassesStudentInfoFn(params).then((res) => {
        this.tableData = res.data;
      });
    },
    getClassesStudentInfo() {
      let params = {
        classId: this.paramslist.classId,
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        searchKey: this.searchKey,
      };
      getClassesStudentInfoFn(params).then((res) => {
        this.tableData = res.data;
    });
    },

    studentAdjustments() {
      //批量调整
      this.allValue = ''
      this.allSessionIdTag = this.paramslist.sessionId
      let params = {
        classId: this.paramslist.classId,
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        sessionIdTarget: this.allSessionIdTag //考场id（要调入的）
      };
      getOtherClassesFn(params).then((res) => {
        this.optionsList = res.data
      
      });
      if (this.selectIds.length > 0) {
        this.selectidsLength = this.selectIds.length;
        this.alladdDialog = true;
      } else {
        this.$message.warning("请选择要调整的学生");
      }
     
      this.leftSeatshow = false;
      this.getPlanAllSession();
    },
    allAddSchool() {//批量调整确定
      let studentCourseIds = [];
      studentCourseIds = this.selectIds.join();
      let changeTpuelist = {
        changeType: "2",
        classId: this.paramslist.classId,
        classIdTarget: this.allclassIdTarget, //考场id（要调入的）allclassIdTarget
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        studentCount: "",
        studentCourseIds: studentCourseIds,
        sessionIdTarget: this.allSessionIdTag, //要调入的场次id
      };
      saveChangePlanClassFn(changeTpuelist).then((res) => {
        this.alladdDialog = false;
        this.allclassIdTarget = "";
        this.allSessionIdTag = "";
        if (res.code == 1) {
          this.getClassesStudentInfo();
          this.$message.success(res.data);
        }
      });
    },
    addSchool(row) {
      //单个调整
      let changeTpuelist = {
        changeType: "2",
        classId: this.paramslist.classId,
        classIdTarget: this.classIdTarget, //考场id（要调入的）classIdTarget
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        studentCount: "",
        studentCourseIds: this.singlestudentCourseId,
        sessionIdTarget: this.sessionIdTag, //要调入的场次id
      };
      saveChangePlanClassFn(changeTpuelist).then((res) => {
        this.addDialog = false;
        this.classIdTarget = "";
        this.sessionIdTag = "";
        if (res.code == 1) {
          this.getClassesStudentInfo();
          this.$message.success(res.data);
        }
      });
    },
    allAdjustment(row) {
      //单个调整
      this.valueplaceId = ''
      this.getPlanAllSession();
      this.sessionIdTag = this.paramslist.sessionId
      this.singlestudentCourseId = row.studentCourseId;
      this.addDialog = true;
      let params = {
        classId: this.paramslist.classId,
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        sessionIdTarget: this.sessionIdTag,
      };
      getOtherClassesFn(params).then((res) => {
        (this.allValue = ""), (this.options = res.data);
      });
    },
    async getOtherClasses() {
      let params = {
        classId: this.paramslist.classId,
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        sessionIdTarget: this.sessionIdTag,
      };
      const { data } = await getOtherClassesFn(params);
      this.leftSeatshow = false;
      this.valueplaceId = "";
      this.classIdTarget = "";
      this.leftSeatNumber = "";
      this.options = data;
    },
    async allgetOtherClasses() {
      let params = {
        classId: this.paramslist.classId,
        placeId: this.paramslist.placeId,
        planId: this.paramslist.planId,
        sessionId: this.paramslist.sessionId,
        sessionIdTarget: this.allSessionIdTag,
      };
      const { data } = await getOtherClassesFn(params);
      this.leftSeatshow = false;
      this.valueplaceId = "";
      this.allValue = "";
      this.leftSeatNumber = "";
      this.optionsList = data;
    },
  },
};
</script>
    
    <style lang="less" scoped>
.topTip {
  width: 100%;
  background-color: #ebf0fa;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
}
.sessionlist {
  margin-top: 10px;
}
.titlelist {
  text-align: left;
  display: flex;
  margin: 20px 15px;

  p {
    margin-left: 50px;
    a {
      width: 58px;
      display: inline-block;
      text-align: right;
    }
  }
}
.leftSeatshow {
  margin: 30px;
}

.titleback {
  background: #fff;
  margin-bottom: 20px;
  display: flex;
}
</style>
    